import { useEffect, type ReactNode } from 'react';
import { Provider } from 'react-redux';
import { hydrateAuth } from '@/store/features/auth/auth-slice';
import { store } from '@/store/store';
import type { IAuthData } from '@/types/auth';

function readPersistedAuth(): IAuthData | null {
  const raw = localStorage.getItem('userData');
  if (raw) {
    try {
      return JSON.parse(raw) as IAuthData;
    } catch {
      localStorage.removeItem('userData');
    }
  }

  const accessToken = localStorage.getItem('access');
  const role = localStorage.getItem('role') as IAuthData['role'] | null;
  return accessToken && role ? { accessToken, refreshToken: '', role } : null;
}

export function StoreProvider({ children }: { children: ReactNode }) {
  useEffect(() => {
    store.dispatch(hydrateAuth(readPersistedAuth()));

    return store.subscribe(() => {
      const userData = store.getState().auth.userData;
      if (userData) {
        localStorage.setItem('userData', JSON.stringify(userData));
        localStorage.setItem('access', userData.accessToken);
        localStorage.setItem('role', userData.role);
      } else {
        localStorage.removeItem('userData');
        localStorage.removeItem('access');
        localStorage.removeItem('role');
      }
    });
  }, []);

  return <Provider store={store}>{children}</Provider>;
}
